import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle, Send, ChevronDown } from "lucide-react";
import "./Blog.css";

const CommentSection = ({ blogId }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [visibleCount, setVisibleCount] = useState(2);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`http://localhost:5000/api/comments/${blogId}`)
      .then((res) => res.json())
      .then((data) => {
        const safeData = Array.isArray(data) ? data : [];
        setComments(safeData);
      })
      .catch((err) => console.error("❌ Error fetching comments:", err));
  }, [blogId, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    const commentObj = {
      content: newComment,
      author: "Anonymous",
      blogId,
    };

    try {
      const res = await fetch(`http://localhost:5000/api/comments`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(commentObj),
      });

      if (res.ok) {
        const saved = await res.json();
        setComments([saved, ...comments]);
        setNewComment("");
        setVisibleCount((prev) => prev + 1);
      }
    } catch (err) {
      console.error("❌ Failed to post comment:", err);
    }
  };

  return (
    <div className="blog-comment-hbt-section">
      <h3>
        <span className="blog-detail-hbt-icon-text">
          <MessageCircle size={18} /> Comments ({comments.length})
        </span>
      </h3>

      <form onSubmit={handleSubmit} className="blog-comment-hbt-form">
        <textarea
          rows="3"
          placeholder="Write your comment..."
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          className="blog-comment-hbt-textarea"
        />
        <button type="submit" className="blog-comment-hbt-submit-btn">
          Post Comment
        </button>
      </form>

      <ul className="blog-comment-hbt-list">
        {comments.slice(0, visibleCount).map((comment, index) => (
          <li key={index} className="blog-comment-hbt-comment">
            <strong className="blog-comment-hbt-author">{comment.author}</strong>
            <span className="blog-comment-hbt-date">
              {new Date(comment.createdAt).toLocaleString()}
            </span>
            <p className="blog-comment-hbt-content">{comment.content}</p>
          </li>
        ))}
      </ul>

      {comments.length > 10 && (
        <button
          onClick={() => navigate(`/blogs/${blogId}/comments`)}
          className="blog-comment-hbt-view-all-btn"
        >
          View All Comments
        </button>
      )}

    </div>
  );
};

export default CommentSection;
